import "./FormSection.scss"
import GenericFields from "../GenericFields/GenericFields"
import Trigger from "../../Trigger/Trigger"
import Guage from '../../Gauge/Gauge';
import Histogram from '../../Histogram/Histogram';
import TimeSeries from "../../TimeSeries/TimeSeries"
import { observer } from "mobx-react";
import { TdsAccordion, TdsAccordionItem } from "@scania/tegel-react";
import { useContext, useEffect } from "react";
import { UserActionContext } from "../../../AppContext";
import ChainDisplay from "../../ChainDisplay/ChainDisplay";
import ChainEditWrapper from "../../ChainEdit/ChainEditWrapper";
import ValueNamesDisplay from "../../ValueNamesDisplay/ValueNamesDisplay";
import ValueNamesEdit from "../../ValueNamesEdit/ValueNamesEdit";
import { useFormContext } from "react-hook-form";

type FormSectionProps = {
  selectedVariableDetails?: VariableDetail | undefined
  isEditor: boolean
}


// TODO : get the mode details in  this component to manipulate the form handling while editing and updating ! 

const FormSection = ({ selectedVariableDetails, isEditor }: FormSectionProps) => {
  const { action, updateWithVersion } = useContext(UserActionContext);
  const { getValues, unregister } = useFormContext();
  const variableType = getValues("type") || selectedVariableDetails?.type ;
  useEffect(() => {
    if (variableType !== 'guage') {
      unregister("value_names")
    }
  }, [variableType,unregister])

  return <div className={`tds-container-fluid tds-background-grey-50 tds-u-p1 tds-u-pt2 tds-u-mt1 form-container ${action}`}>
    <GenericFields selectedVariableDetails={selectedVariableDetails} isEditor={isEditor} />
    {variableType === 'gauge' && <Guage variableData={selectedVariableDetails} isEditor={isEditor} ></Guage>}
    {variableType === 'trigger' && <Trigger variableData={selectedVariableDetails} isEditor={isEditor} ></Trigger>}
    {variableType === 'class' && <Histogram variableData={selectedVariableDetails} isEditor={isEditor} ></Histogram>}
    {variableType === 'time_series' && <TimeSeries variableData={selectedVariableDetails} isEditor={isEditor} ></TimeSeries>}
    {!variableType && <div>Variable type information missing</div>}

    {selectedVariableDetails && <TdsAccordion className="tds-u-mt3">
      {/* //TODO: What about the scenarion when the actions are edit/update ??? */}

      {variableType === 'gauge' && <TdsAccordionItem header="Value names" expanded paddingReset >
        {(action === "read" || (['edit', 'update'].includes(action) && !updateWithVersion)) && <ValueNamesDisplay valueNamesObject={selectedVariableDetails?.value_names} />}
        {(action === "create" || (['edit', 'update'].includes(action) && updateWithVersion)) && <ValueNamesEdit valueNamesObject={selectedVariableDetails?.value_names} />}
        {/* //TODO :  need the same for edit/update */}
      </TdsAccordionItem>}
      <TdsAccordionItem header="Chain *" expanded paddingReset>
        {(action === "read" || (['edit', 'update'].includes(action) && !updateWithVersion)) && <ChainDisplay chainData={selectedVariableDetails?.chain} />}
        {(action === "create" || (['edit', 'update'].includes(action) && updateWithVersion)) && <ChainEditWrapper variable={selectedVariableDetails} action={action} />}
      </TdsAccordionItem>
    </TdsAccordion>}
  </div>
}

export default observer(FormSection)

